module.exports = __webpack_public_path__ + "img/11-11.8842870c.jpeg";